/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetAspectRatio } from './assetAspectRatio';


export interface AssetVersion { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    /**
     * the original filename
     */
    name: string;
    version: number;
    defaultAspectRatio: string;
    aspectRatios?: Array<AssetAspectRatio>;
    metadata?: object;
    annotations?: object;
    annotationsCount?: number;
}

